import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-simples',
  templateUrl: './modal-simples.component.html',
  styleUrls: ['./modal-simples.component.scss'],
})
export class ModalSimplesComponent implements OnInit {
  constructor() { }
  @Input() title: string = '';
  @Input() message?: string = '';
  @Input() exibirBtnFechar: boolean = false;
  @Input() exibirBtnFecharHeader: boolean = true;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  // Método para confirmar
  onConfirm() {
    this.confirm.emit();
  }

  // Método para cancelar
  onCancel() {
    this.cancel.emit();
  }
  ngOnInit(): void { }
}
